import VendorLogin from "components/manager/views/pages/admin/login/venderLogin";
import { Route, Routes } from "react-router-dom";
import AccountSalesStatistics from "routes/admin/vendor/sales/AccountSalesStatistics";
import ProductSalesStatistics from "routes/admin/vendor/sales/ProductSalesStatistics";
import VendorStatistics from "routes/admin/vendor/sales/VendorStatistics";
import EmptyPage from "routes/empty/EmptyPage";
import VendorLayout from "routes/vendor/VendorLayout";
import RequireAdminAuth from "shared/utils/RequireAdminAuth";

function VendorRouter({ allowedRoles }) {
  return (
    <Routes>
      <Route
        path=""
        element={
          <RequireAdminAuth
            allowedRoles={["member", "admin"]}
            to="/vendor/login"
          />
        }
      >
        <Route path="" element={<VendorLayout />}>
          {/* 홈 */}
          <Route path="" element={<VendorStatistics />} />
          {/* 통계 */}
          <Route path="product" element={<ProductSalesStatistics />} />
          <Route path="customer" element={<AccountSalesStatistics />} />
        </Route>
      </Route>
      <Route path="login" element={<VendorLogin />} />
      <Route path="*" element={<EmptyPage target="/vendor" />} />
    </Routes>
  );
}

export default VendorRouter;
